/* tslint:disable */
/* eslint-disable */
/**
 * MVC Games
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PagingOutput
 */
export interface PagingOutput {
    /**
     * 
     * @type {number}
     * @memberof PagingOutput
     */
    totalCount: number;
}

/**
 * Check if a given object implements the PagingOutput interface.
 */
export function instanceOfPagingOutput(value: object): value is PagingOutput {
    if (!('totalCount' in value) || value['totalCount'] === undefined) return false;
    return true;
}

export function PagingOutputFromJSON(json: any): PagingOutput {
    return PagingOutputFromJSONTyped(json, false);
}

export function PagingOutputFromJSONTyped(json: any, ignoreDiscriminator: boolean): PagingOutput {
    if (json == null) {
        return json;
    }
    return {
        
        'totalCount': json['total_count'],
    };
}

export function PagingOutputToJSON(json: any): PagingOutput {
    return PagingOutputToJSONTyped(json, false);
}

export function PagingOutputToJSONTyped(value?: PagingOutput | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'total_count': value['totalCount'],
    };
}

